/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {DeleteTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const deleteTile = (request: DeleteTileRequest, options?: CashRequestOptions) => post<DeleteTileRequest, DeleteTileResponse>("/2.0/cash/delete-tile", request, {...options, rejectOnError: true })